<!--<ul class="navbar">
  <li class="nav-item" style="float:left">Danh sách lớp đang theo học</li>
  <li class="nav-item active">
    <a class="nav-link" (click)="save_chondoituong()">
      <i style="color:red" class="fa-2x mr-2 far fa-window-close"></i>
      Thoát
    </a>
  </li>

</ul>-->



<div class="row">
  <div class="col-8">
    <!--<label class="control-label" style="font-weight:bold;color:cornflowerblue">Danh sách lớp đang theo học</label>-->
    <button class="btn btn-info btn-primary" style="float:right;margin-right:6px" (click)="search()">
      <i class="fas fa-search"></i>
      {{'Tìm kiếm' | translate}}
    </button>
  </div>
  <div class="col-4">
    <ng-select #slChiNhanh
               class="twcollong"
               [tabIndex]="4"
               [openOnEnter]="false"
               [items]="dschinhanhs"
               bindValue="Id"
               bindLabel="Ten"
               tabindex="25"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               [(ngModel)]="TimKiems.DonViId">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>

<!-- lưới chi tiết -->
<div style="padding: 2px 10px 10px 10px;color:black !important; height: calc(100vh - 200px)">
  <div class="row">
    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead [ngClass]="{'theadcss': totalItems>16}">
        <!--<thead>-->
        <tr>
          <th style="width:40px;text-align:center;background-color:#f3f8fc">STT</th>
          <th style="width:50px;text-align:center;background-color:#f3f8fc">{{'Chọn' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Trạng thái</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên học viên</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Ngày sinh</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Giới tính</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên phụ huynh</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Số điện thoại</th>
          <th style="min-width:120px;text-align:left;background-color:#f3f8fc">Phụ trách</th>


        </tr>

        <tr class="filter-row">
          <td style="text-align:center"></td>
          <td style="text-align:center">
            <input type="checkbox" [(ngModel)]="TatCa" (click)="TichTatCa()" />
          </td>
          <td style="text-align:center">
            <ng-select #slTrangThai
                       class="twcollong"
                       [tabIndex]="3"
                       [openOnEnter]="false"
                       [items]="dstrangthais"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       (change)="changeTrangThai($event)"
                       [(ngModel)]="TimKiems.TrangThai">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </td>


          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.HoTen" placeholder="Gõ ký tự và ấn enter" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <!--<input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.TaiKhoan" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>-->
          </td>
          <td>
            <!--<input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.BiDanh" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>-->
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.TenPhuHuynh" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.SoDienThoai" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.PhuTrach" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>

        </tr>

      </thead>
      <tbody style="height:calc(100vh - 260px);">
        <tr *ngFor="let u of datas">
          <td style="width:40px;text-align:center"><a>{{u.STT}}</a></td>
          <td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>
          <td style="min-width:120px">
            <div class="x-grid-cell-inner" style="text-align: center;">
              <a *ngIf="u.TT==1" style="background-color: #000!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #FFFFFF;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==9" style="background-color: #5d7fdd!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==10" style="background-color: #6200ee!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==5" style="background-color: #2cbc63!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==12" style="background-color: #95D03A!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==13" style="background-color: #9d070e!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==2" style="background-color: #570f89!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==4" style="background-color: #b64dff!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==16" style="background-color: #a909bd!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==8" style="background-color: #fa6400!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==3" style="background-color: #e4ff00!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #000;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==7" style="background-color: #00FFFF!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #000;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==14" style="background-color: #dfdfdf!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #000;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==11" style="background-color: #96939b!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==15" style="background-color: #780707ad !important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==6" style="background-color: #FF0000!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;" >
                {{u.TrangThai}}
              </a>



            </div>
          </td>
          <td style="min-width:120px"><a>{{u.HoVaTen}}</a></td>
          <td style="min-width:120px"><a>{{u.NgaySinh | date:'dd/MM/yyyy'}}</a></td>
          <td style="min-width:120px"><a>{{u.GioiTinh}}</a></td>
          <td style="min-width:120px"><a>{{u.TenPhuHuynh}}</a></td>
          <td style="min-width:120px"><a>{{u.DienThoaiDiDong}}</a></td>
          <td style="min-width:120px">{{u.PhuTrach}}</td>

        </tr>
      </tbody>
    </table>


  </div>

</div>





<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>
    <div *ngIf="totalItems>=10">
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled:currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li>
          <input type="number" style="width:50px;height:25px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
        </li>
        <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
      </ul>
    </div>
  </div>
  <div class="">
    <button type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">{{'Lưu lại' | translate}}</button>
    <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
  </div>

</div>








